import { KeyTitleModel } from "./key-value-model";
import { RestaurantListType } from "./restaurant-details";

export class Business {
  approval: number = 0;
  branchId: number = 0;
  name: string = "";
  typeId: number;
  typeName: string;
  cuisineId: number;
  cuisineName: string;
  cityId: number;
  cityName: string;
  priceRangeTypeId: number;
  priceRange: string = "";
  address: string = "";
  description: string = "";
  phoneNumber: string = "";
  website: string;
  instagram: string;
  twitter: string;
  businessMessage: string;
  amenities: KeyTitleModel[] = [];
  membershipAppCompanyBusinessHourList: any = [];
  membershipBusinessImagesList: BusinessImage[] = [];
  membershipAppMealTypeList: any[] = [];
  status: string;
  lat?: number = 0;
  lng?: number = 0;
  addressLine2: string;
  showPublishButton?: boolean;
  businessPartnerId: number = 0;
  lastProductNumber: string = '';
  sourceCurrency: string;
  averageRating?: number = 0.0;
  totalReviews?: number = 0;
  isPreRegistration: boolean = false;
}

export class BusinessImage {
  imagePath: string;
  imageType: number;
  id: number;
  memberShipImageConfigurationViews?: any = [];
}

export class BusinessMenu {
  id: number = 0;
  title: string = "";
  price: string = "";
  productCategoryId: number;
  description: string;
  isFromMembershipApp: boolean = true;
  productBranchMappings: any = [];
  productModifierMappings: any[] = [];
  productImageUrl: string = "";
  productImageId: number = 0;
  productCategory: any = [];
  productImages: any = [];
}
export class BusinessHour {
  id: number;
  Day: string;
  From: string;
  To: string;
  isOpen: boolean = true;
}

export class BusinessFilter {
  public offset: number;
  public limit: number;
  public search: string;
  public sortingType: RestaurantListType;
  public FilterByRating: string;
  public FilterByPriceRange: string;
  public FilterByMealType: string;
  public FilterByCategories: string;
  public origin_Lat: string;
  public origin_long: string;
  public timeZoneOffset: number;
  public isOpen: boolean;
  public zoomLevel: number = 20;
  public north: string;
  public south: string;
  public east: string;
  public west: string;
  public enableZoomFallBack: boolean;
  // Despite the name, TRUE is the production behaviour. The backend maps it to
  // dbo.GetBlissBusinessListStoreProcedureTest, which returns the curated subset
  // (12 vetted businesses on staging); FALSE hits ...StoreProcedure, which also
  // returns unvetted/junk entries ("Test bliss business 04", "1_S_FS", ...).
  // Verified against staging 2026-08-20. Do not flip without backend-side curation.
  public isForTest: boolean = true;
}

export class PreRegisterImageGroupResponse {
  public batchId: number;
  public csvFileName: string;
  public totalImages: number;
  public totalProcessedImages: number;
  public createdOn: string;
  public createdById: number;
  public createdBy: KeyTitleModel;
  public imageData: PreRegisterBusinessImageData[] = [];
}

export class PreRegisterBusinessImageData {
  public id: number;
  public branchId: number;
  public businessId: number;
  public imageName: string;
  public imageTypeId: MembershipBranchImageType;
  public isCropped: boolean;
  public isBatchCompleted: boolean;
  public imageId: number;
  public businessName: string;
  public approvalStatus: number = 0;
}

export class GroupedImageType {
  public imageTypeId: MembershipBranchImageType;
  public isAllTypeImagesUploaded: boolean;
  public totalImages: number;
  public totalUploadedImages: number;
  public imageTypeData: {
    id: number;
    branchId: number;
    imageName: string;
    isCropped: boolean;
    isBatchCompleted: boolean;
    imageId: number;
    businessName: string;
  }[];
}

export class GroupedBusiness {
  public businessId: number;
  public businessName: string;
  public approvalStatus: number;
  public isAllBusinessImagesUploaded: boolean;
  public businessImageData: GroupedImageType[];
}

export class ImageItem {
  public id: number;
  public branchId: number;
  public businessId: number;
  public imageName: string;
  public imageTypeId: MembershipBranchImageType;
  public isCropped: boolean;
  public isBatchCompleted: boolean;
  public imageId: number;
  public businessName: string;
  public total: number;
  public index: number;
  public approvalStatus: number;
}

export enum MembershipBranchImageType {
  Facade = 1,
  Interior = 2,
  Counter = 3,
  Kitchen = 4,
  Seating = 5,
  Other = 6,
  FoodDrink = 7,
  UserSubmissions = 8
}
